import { render } from "./Module_Properties.vue?vue&type=template&id=8406522a&scoped=true"
import script from "./Module_Properties.vue?vue&type=script&lang=js"
export * from "./Module_Properties.vue?vue&type=script&lang=js"

import "./Module_Properties.vue?vue&type=style&index=0&id=8406522a&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Florian\\Work\\Sportips\\NOUVEAUX MODULES\\inscription\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8406522a"]])

export default __exports__